export default [
  {
    path: '/webhooks',
    name: 'webhooks',
    component: () => import('@/app-modulo/comuns/webhooks/WebhooksConfiguracao.vue'),
    meta: {
      resource: 'webhooks',
      action: 'create',
      pageTitle: 'Configurações de Webhooks',
      breadcrumb: [],
    },
  },
]
